import { combineReducers } from 'redux';
import summary from './summary/reducer';
import pricingParameters from './pricingparameters/reducer';
import impactSummary from './impactsummary/imimpactsummary/reducer';
import tradePricedToday from './impactsummary/tradepricedtoday/reducer';
import impactDetailed from './impactdetailed/reducer';
import idSummary from './impactAnalysisIdSummary/reducer';

export default combineReducers({
    summary,
    pricingParameters,
    impactSummary,
    tradePricedToday,
    impactDetailed,
    idSummary
});
